import { render, staticRenderFns } from "./detailView.vue?vue&type=template&id=2851e0fa&scoped=true&"
import script from "./detailView.vue?vue&type=script&lang=js&"
export * from "./detailView.vue?vue&type=script&lang=js&"
import style0 from "./detailView.vue?vue&type=style&index=0&id=2851e0fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2851e0fa",
  null
  
)

export default component.exports